<template>
<div class="DModel">
  <el-row :gutter="20" class="inner">
    <el-col :span="8" class="left">
      <div class="lefttabs">
        <div class="title">送检信息</div>
        <div class="innerForm">
          <el-form label-width="120px" labelPosition='left'>
            <el-form-item label="订单号：">
              <el-input   :value="previewData.code" disabled></el-input>
            </el-form-item>
            <el-form-item label="客户编码：">
              <el-input   :value="previewData.gdAccount" disabled></el-input>
            </el-form-item>
            <el-form-item label="客户名称：">
              <el-input    :value="previewData.deptName" disabled></el-input>
            </el-form-item>
            <el-form-item label="送检人：">
              <el-input  :value="previewData.createUserName" disabled></el-input>
            </el-form-item>
            <el-form-item label="送检人部门：">
              <el-input  :value="previewData.deptName" disabled></el-input>
            </el-form-item>
            <el-form-item label="证书单位：">
              <el-input   :value="previewData.deptName" disabled></el-input>
            </el-form-item>
            <el-form-item label="证书单位地址：">
              <el-input   :value="previewData.deptAddress" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系人：">
              <el-input   :value="previewData.createUserName" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系人电话：">
              <el-input   :value="previewData.phoneNumber" disabled></el-input>
            </el-form-item>
            <!-- <el-form-item label="联系电话：">
              <el-input :value="'无'" disabled></el-input>
            </el-form-item>
            <el-form-item label="传真号：">
              <el-input :value="'无'" disabled></el-input>
            </el-form-item> -->
            <el-form-item label="仪器地点：">
              <el-input    :value="previewData.depotAddress" disabled></el-input>
            </el-form-item>
            <el-form-item label="服务方式：">
              <el-input    :value="'上门自取'" disabled></el-input>
            </el-form-item>
            <el-form-item label="检定机构：">
              <el-input   :value="previewData.mechanismName" disabled></el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input
                v-model="previewData.remark"
                type="textarea"
                placeholder="请输入备注"
                :rows="4"
                 maxlength="300"
                :disabled="previewData.states === 3 || previewData.states === 4 || previewData.states === 5"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-col>
    <el-col :span="16" class="right">
      <el-tabs class="tabs" type="border-card" v-model="tabsValue" v-if="previewData.detail.length > 0">
        <el-tab-pane :label="item.instrumentName" :name="String(item.instrumentId)" :key="item.instrumentId" v-for="(item) in previewData.detail" class="tabp">
          <el-row type="flex">
            <el-col :span="12">
              <el-form label-width="140px" labelPosition='left'>
                <el-form-item label="仪器名称：">
                  <el-input    :value="item.instrumentName" disabled></el-input>
                </el-form-item>
                <el-form-item label="仪器型号：">
                  <el-input   :value="item.pattern" disabled></el-input>
                </el-form-item>
                <el-form-item label="管理编号：">
                  <el-input   :value="item.serialNumber" disabled></el-input>
                </el-form-item>
                <el-form-item label="出厂编号：">
                  <el-input  :value="item.factoryNumber" disabled></el-input>
                </el-form-item>
                <template v-if="item.states === -1 || item.states === 1 || item.states === 2 || item.states === 3">
                  <el-form-item label="最新证书编号：">
                    <el-input   :value="item.oldCertificateNo" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="最近检定日期：">
                    <el-input :value="item.lastCalibrationTime" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="最近有效日期：">
                    <el-input :value="item.validityEffectiveTime" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="最近检定机构：">
                    <el-input   :value="item.calibrationMechanism" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="送检结果：">
                    <el-input :value="showDetailState(item.states)"  disabled></el-input>
                  </el-form-item>
                  <el-form-item label="原因：" v-if="item.states === 3">
                    <el-input :value="item.explain"   disabled></el-input>
                  </el-form-item>
                  <el-form-item label="处理结果：" v-if="item.states === 5">
                    <el-input   :value="showDetailStatus(item.status)" disabled></el-input>
                  </el-form-item>
                </template>
              </el-form>
            </el-col>
            <el-col :span="12" class="btnsCol">
              <div class="btns">
                <div class="operateBtn" @click="deleteDetail(item.id)" v-if="item.states === 1">删除</div>
                <div class="operateBtn" @click="revokeDetail(item.id)" v-if="item.states === 2">撤销</div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form label-width="140px" labelPosition='left'>
                <el-form-item label="检定要求：">
                  <el-input
                    v-model="item.sendRemark"
                    type="textarea"
                    placeholder="请输入检定要求"
                    :rows="6"
                    maxlength="300" 
                    :disabled="item.states === 3 || item.states === 4 || item.states === 5"
                  ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <template v-if="item.states === 4 || item.states === 5">
            <div class="linediv"></div>
            <el-row type="flex">
              <el-col :span="12">
                <el-form label-width="140px" labelPosition='left'>
                  <el-form-item label="证书编号：">
                    <el-input  :value="item.certificateNo" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="证书有效期(开始)：">
                    <el-input :value="item.dueStartDate" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="证书有效期(结束)：">
                    <el-input :value="item.dueEndDate" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="计量结论：">
                    <el-input :value="item.conclusion" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="送检结果：">
                    <el-input :value="showDetailState(item.states)" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="处理结果：" v-if="item.states === 5">
                    <el-input :value="showDetailStatus(item.status)" disabled></el-input>
                  </el-form-item>
                  <el-form-item v-if="item.states === 4 || item.states === 5">
                    <el-link type="primary" @click="download(item)">下载证书</el-link>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="12" class="opCol" v-if="item.states === 4">
                <el-form label-width="140px" labelPosition='left'>
                  <el-form-item label="结果处理：">
                    <div class="operateBtn" @click="showQualified(item.id)">合格</div>
                    <div class="operateBtn" @click="showDemotion(item)">降级使用</div>
                    <div class="operateBtn" @click="scrap(item.id)">停用</div>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </template>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
  <div class="footer">
    <div class="jb-bg btn" @click="save" v-if="showSave">保存</div>
    <div class="jb-bg btn" @click="submitFiles" v-if="showSubmit">送检所有仪器</div>
    <div class="jb-bg btn" @click="deleteOrder" v-if="previewData.states === 1">删除</div>
    <div class="jb-bg btn" @click="revokeOrder" v-if="previewData.states === 2">撤销</div>
    <div class="btn" @click="hide">取消</div>
  </div>
  <!-- 合格 -->
  <el-dialog :visible.sync="qualifiedVisible" width="500px" v-if="qualifiedVisible" append-to-body :close-on-click-modal="false">
    <qualifiedModel @cancel="cancelQualified" @qualified="qualified"></qualifiedModel>
  </el-dialog>
  <!-- 降级使用 -->
  <el-dialog :visible.sync="posp" width="1000px" v-if="posp" append-to-body class="popout model" title="修改数据" :close-on-click-modal="false">
    <redactModel :itemData="particular" @operation="operation" @cancel="cancelDemotion" type="vertifyorder"></redactModel>
  </el-dialog>
</div>
</template>

<script>
import { DeleteDetail, RevokeDetail, GetOne, Qualified, GetInstrument, Demotion, Scrap } from "@/api/VertifyOrder";
import { FileUrl } from "@/api/depotApi";
import qualifiedModel from "./components/qualifiedModel.vue";
import redactModel from "@/components/redactModel";
export default {
  props: ['preData'],
  components: {
    qualifiedModel,
    redactModel,
  },
  data: function() {
    return {
      previewData: {},
      qualifiedVisible: false,
      detailId: -1,
      posp: false,
      pospid: '',
      tabsValue: '',
    }
  },
  computed: {
    showSave() {
      switch (this.previewData.states) {
        case -1:
          return true;
        case 1:
          return true;
        case 2:
          return true;
        case 4:
          if (this.previewData.detail && this.previewData.detail.length > 0) {
            return this.previewData.detail.some(function(item) {
              return item.states === 2
            })
          }
          return false;
        case 5:
          return false;
        default:
          return false;
      }
    },
    showSubmit() {
      switch (this.previewData.states) {
        case -1:
          return true;
        case 1:
          return true;
        default:
          return false;
      }
    }
  },
  created() {
    this.previewData = this.preData;
    if (this.preData.detail && this.preData.detail.length > 0) {
      this.tabsValue = String(this.preData.detail[0].instrumentId);
    }
  },
  methods: {
    save() {
      let de = this.previewData.detail.map(item => {
        return {
          instrumentId: item.instrumentId,
          sendRemark: item.sendRemark,
          id: item.id,
        }
      })
      let data = {
        deptId: this.previewData.deptId,
        depotId: this.previewData.depotId,
        createUser: this.previewData.createUser,
        mechanismId: this.previewData.mechanismId,
        remark: this.previewData.remark,
        detail: de,
        states: 1,
        id: this.previewData.id,
      }
      this.$emit("save", data);
    },
    submitFiles() {
      let de = this.previewData.detail.map(item => {
        return {
          instrumentId: item.instrumentId,
          sendRemark: item.sendRemark,
          id: item.id,
        }
      })
      let data = {
        deptId: this.previewData.deptId,
        depotId: this.previewData.depotId,
        createUser: this.previewData.createUser,
        mechanismId: this.previewData.mechanismId,
        remark: this.previewData.remark,
        detail: de,
        states: 2,
        id: this.previewData.id,
      }
      this.$emit("submitFiles", data);
    },
    hide() {
      this.$emit("cancel");
    },
    deleteDetail(id) {
      let self = this;
      this.$confirm(
        `确定删除吗?`,
        "删除提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          DeleteDetail({ detailId: id }).then(res => {
            if (res.code === '200') {
              self.$message.success('删除成功');
              GetOne(self.previewData.id).then((res) => {
                self.previewData = res.data;
                if (res.data.detail && res.data.detail.length > 0) {
                  self.tabsValue = String(res.data.detail[0].instrumentId);
                }
              })
            }
            else {
              self.$message.success('删除失败');
            }
          })
        })
        .catch(() => {});
    },
    revokeDetail(id) {
      let self = this;
      this.$prompt('请输入备注', '是否确认撤销', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        RevokeDetail({ detailId: id, explain: value }).then(res => {
          if (res.code === '200') {
            self.$message.success('撤销成功');
            GetOne(self.previewData.id ).then((res) => {
              self.previewData = res.data;
            })
          }
          else {
            self.$message.success('撤销失败');
          }
        });
      }).catch(() => {

      });
    },
    deleteOrder() {
      this.$confirm(
        `确定删除吗?`,
        "删除提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          this.$emit("deleteOrder", this.previewData.id);
        })
        .catch(() => {});
    },
    revokeOrder() {
      this.$prompt('请输入备注', '是否确认撤销', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.$emit("revokeOrder", { orderId: this.previewData.id, explain: value });
      }).catch(() => {

      });
    },
    showQualified(id) {
      this.qualifiedVisible = true;
      this.detailId = id;
    },
    cancelQualified() {
      this.qualifiedVisible = false;
    },
    qualified(path) {
      let self = this;
      Qualified({ detailId: this.detailId, screenPath: path }).then(res => {
        if (res.code === '200') {
          self.$message.success('操作成功，已生成检定记录及检定确认表');
          self.qualifiedVisible = false;
          GetOne(self.previewData.id).then((res) => {
            self.previewData = res.data;
          })
        }
        else {
          self.$message.success('操作失败');
        }
      })
    },
    // 降级使用-获取仪器信息
    showDemotion(data) {
      GetInstrument(data.instrumentId).then(res => {
        this.posp = true;
        this.pospid = data.id;
        this.particular = res.data;
      });
    },
    cancelDemotion() {
      this.posp = false;
      this.pospid = '';
    },
    operation(data) {
      let self = this;
      let params = {
        detailId: this.pospid,
        screenPath: data.resultPicFile,
        standards: data.standards,
        checkParams: data.checkParams,
      }
      Demotion(params).then(res => {
        if (res.code === '200') {
          self.$message.success('操作成功，已生成检定记录及检定确认表');
          self.posp = false;
          self.pospid = '';
          GetOne(self.previewData.id).then((res) => {
            self.previewData = res.data;
          })
        }
        else {
          self.$message.success('操作失败');
        }
      })
    },
    showDetailState(state) {
      switch (state) {
        case 1:
          return '待送检';
        case 2:
          return '已送检';
        case 3:
          return '撤销';
        case 4:
          return '待确认';
        case 5:
          return '已完成';
      }
    },
    showDetailStatus(status) {
      switch (status) {
        case 0:
          return '待处理';
        case 1:
          return '报废';
        case 2:
          return '降级使用';
        case 3:
          return '合格';
      }
    },
    scrap(id) {
      let self = this;
      this.$confirm(
        `确定停用吗?`,
        "停用提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          Scrap({ detailId: id }).then(res => {
            if (res.code === '200') {
              self.$message.success('停用成功');
              GetOne(self.previewData.id).then((res) => {
                self.previewData = res.data;
              })
            }
            else {
              self.$message.success('停用失败');
            }
          })
        })
        .catch(() => {});
    },
    // 下载证书
    download(row) {
      FileUrl({ objectName : row.certFile }).then((res) => {
        if (res.code == 200) {
          window.open(res.data)
        }
      });
    },
  },
}
</script>

<style lang="less" scoped>
.DModel {
  color: #74c8fe;
  height: 750px;
  .inner {
    height: 680px;
    .left {
      height: 100%;
      .lefttabs {
          background: #FFF;
          border: 1px solid #DCDFE6;
          box-shadow: 0 2px 4px 0 #0000001f, 0 0 6px 0 #0000000a;
          height: 100%;
          padding: 0 15px;
        .title {
          height: 40px;
          line-height: 40px;
          text-align: center;
          margin-bottom: 10px;
        }
        .innerForm {
          height: calc(100% - 50px);
          overflow: auto;
          .el-form-item {
            margin-bottom: 10px;
            /deep/ .el-form-item__label {
              line-height: 30px;
            }
            /deep/ .el-form-item__content {
              line-height: 30px;
            }
            /deep/ .el-input__inner {
              height: 30px;
              line-height: 30px;
            }
          }
        }
      }
    }
    .right {
      height: 100%;
      .tabs {
        height: 100%;
        /deep/ .el-tabs__content {
          height: calc(100% - 40px);
          padding: 0;
          .tabp {
            height: 100%;
            overflow: auto;
            padding: 15px;
            box-sizing: border-box;
            .el-form-item {
              margin-bottom: 10px;
              .el-form-item__label {
                line-height: 30px;
              }
              .el-form-item__content {
                line-height: 30px;
              }
              .el-input__inner {
                height: 30px;
                line-height: 30px;
              }
            }
          }
        }
        .btnsCol {
          display: flex;
          align-items: center;
          justify-content: center;
          .btns {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .operateBtn {
              width: 110px;
              border: 2px solid #0090f0;
              border-radius: 6px;
              height: 22px;
              line-height: 22px;
              margin: 0 10px;
              text-align: center;
              cursor: pointer;
              margin: 10px 0px;
            }
          }
          .handleLabel {
            display: flex;
            align-items: center;
            justify-content: flex-start ;
            flex-direction: column;
          }
          .handleBox{
            border-style: solid;
            border-radius: 2px;
          }
        }
        .linediv {
          height: 1px;
          width: 100%;
          margin: 10px 0;
          background-color: #dcdfe6;
        }
        .opCol {
          margin-left: 15px;
          border-left: 1px solid #dcdfe6;
          padding-left: 15px;
          .operateBtn {
            width: 110px;
            border: 2px solid #0090f0;
            border-radius: 6px;
            height: 22px;
            line-height: 22px;
            margin: 0 10px;
            text-align: center;
            cursor: pointer;
            margin: 10px 0px;
          }
        }
      }
    }
  }
  .footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .btn {
      width: 150px;
      border: 2px solid #0090f0;
      border-radius: 6px;
      height: 30px;
      line-height: 30px;
      margin: 0 10px;
      text-align: center;
      cursor: pointer;
    }
  }
  .jb-bg {
    background-image: linear-gradient(#0479b4, #02407e);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/previewModel/index.vue